/*
 * Dawn global helpers.
 *
 * Elare's secondary.js calls trapFocus (6x), removeTrapFocus (4x), pauseAllMedia (3x) and
 * debounce (3x), but never defines them: in Dawn they live in global.js, which this theme
 * does not ship (it 404s on the source CDN too). The first call therefore threw
 * "trapFocus is not defined" inside HeaderDrawer.openMenuDrawer, which aborted the method
 * after it had added the `menu-opening` class but before the drawer could open — so the
 * menu looked dead.
 *
 * These are the standard Dawn implementations. Each is guarded so that if a real global.js
 * is ever loaded it wins instead of being clobbered.
 * Must execute BEFORE secondary.js, hence a blocking script in <head>.
 */
(function () {
  if (typeof window.getFocusableElements !== 'function') {
    window.getFocusableElements = function (container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
  }

  var handlers = {};

  if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = function (elementToFocus) {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (elementToFocus) elementToFocus.focus();
    };
  }

  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function (container, elementToFocus) {
      if (!container) return;
      elementToFocus = elementToFocus || container;

      var elements = window.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      window.removeTrapFocus();

      handlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', handlers.keydown);
      };

      handlers.focusout = function () {
        document.removeEventListener('keydown', handlers.keydown);
      };

      handlers.keydown = function (event) {
        if (!event.code || event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          if (first) first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          if (last) last.focus();
        }
      };

      document.addEventListener('focusout', handlers.focusout);
      document.addEventListener('focusin', handlers.focusin);

      try {
        elementToFocus.focus();
        if (
          elementToFocus.tagName === 'INPUT' &&
          ['search', 'text', 'email', 'url'].indexOf(elementToFocus.type) !== -1 &&
          elementToFocus.value
        ) {
          elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
      } catch (e) {
        /* focusing a hidden or detached node must never break the caller */
      }
    };
  }

  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function () {
      document.querySelectorAll('.js-youtube').forEach(function (video) {
        if (video.contentWindow) {
          video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
      });
      document.querySelectorAll('.js-vimeo').forEach(function (video) {
        if (video.contentWindow) video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
        } catch (e) {}
      });
      document.querySelectorAll('product-model').forEach(function (model) {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    };
  }

  if (typeof window.debounce !== 'function') {
    window.debounce = function (fn, wait) {
      var timer;
      return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, wait || 0);
      };
    };
  }
})();
